import React from 'react'
import PropTypes from 'prop-types'
import upperCase from 'lodash/upperCase'
import {useTranslation} from 'react-i18next'
import {UserContext} from '../../../context/User'
import UserEditBox from '../../AuditDetailTab/UserEditBox'
import {getLastAuditPeriod, getNextAuditPeriod} from '../../../utils/auditDatePeriodFormatter'
import auditRecurringFormatter from '../../../utils/auditRecurringFormatter'

function Details({data, isTemplate, permission}) {
  const {t} = useTranslation()
  const user = React.useContext(UserContext)
  const user_edit_permission = permission
    ? data.audit_type_for_user === 'created' || user.details.is_admin
    : false
  return (
    <div className="row">
      <div className={isTemplate ? 'col-md-5' : 'col-md-4'}>
        {isTemplate && (
          <div className="audit-expand__column">
            <span className="audit__label">
              {upperCase(`${t('audit.expand.labels.used_count')}`)}
            </span>
            <span className="audit__value mb_10">{data.used_count}</span>
            <span className="audit__label">
              {upperCase(`${t('audit.expand.labels.scan_after_due_date')}`)}
            </span>
            <span className="audit__value mb_10">
              {data.allow_scanning_after_due_date ? 'Yes' : 'No'}
            </span>
            <span className="audit__label">
              {upperCase(`${t('audit.expand.labels.recurrence')}`)}
            </span>
            <span className="audit__value">
              {auditRecurringFormatter(data.recurrence_attributes)}
            </span>
          </div>
        )}

        {!isTemplate &&
          (user_edit_permission ? (
            <div className="audit-expand__column">
              {data.due_date && data.due_date !== '12/31/2100' && (
                <>
                  <span className="audit__label">
                    {upperCase(`${t('audit.expand.labels.due_date')}`)}
                  </span>
                  <span className="audit__value mb_10">{data.due_date}</span>
                </>
              )}
              <span className="audit__label">
                {upperCase(`${t('audit.expand.labels.assigned_by')}`)}
              </span>
              <span className="audit__value">{data.user_name}</span>
            </div>
          ) : (
            <div className="audit-expand__column">
              <span className="audit__label">
                {upperCase(`${t('audit.expand.labels.scanned_items')}`)}
              </span>
              <span className="audit__value mb_10">
                {`${data.scanned_items_count} / ${data.total_items_count}`}
              </span>
              <span className="audit__label">
                {upperCase(`${t('audit.expand.labels.new_items')}`)}
              </span>
              <span className="audit__value mb_10">
                {data.added_item_count ? data.added_item_count : 0}
              </span>
              <span className="audit__label">
                {upperCase(`${t('audit.expand.labels.added_items')}`)}
              </span>
              <span className="audit__value">{data.new_item_count ? data.new_item_count : 0}</span>
            </div>
          ))}
      </div>
      <div className={isTemplate ? 'col-md-7' : 'col-md-8 z-index-9'}>
        {isTemplate && (
          <div className="audit-expand__column pl_8">
            <span className="audit__label">
              {upperCase(`${t('audit.expand.labels.last_audit_period')}`)}
            </span>
            <span className="audit__value mb_10">{getLastAuditPeriod(data.last_audit_period)}</span>
            <span className="audit__label">
              {upperCase(`${t('audit.expand.labels.next_audit_period')}`)}
            </span>
            <span className="audit__value mb_10">{getNextAuditPeriod(data.next_audit_period)}</span>
          </div>
        )}

        {!isTemplate &&
          (user_edit_permission ? (
            <UserEditBox audit={data} />
          ) : (
            <div className="audit-expand__column pl_8">
              {data.template_name && (
                <>
                  <span className="audit__label">
                    {upperCase(`${t('audit.expand.labels.audit_template')}`)}
                  </span>
                  <span className="audit__value mb_10">{data.template_name}</span>
                </>
              )}
              {data.due_date && (
                <>
                  <span className="audit__label">
                    {upperCase(`${t('audit.expand.labels.scan_after_due_date')}`)}
                  </span>
                  <span className="audit__value mb_10">
                    {data.allow_scanning_after_due_date ? 'Yes' : 'No'}
                  </span>
                </>
              )}
              <span className="audit__label">
                {upperCase(`${t('audit.expand.labels.audit_method')}`)}
              </span>
              <span className="audit__value mb_10">{t(`audit.methods.${data.method}`)}</span>
            </div>
          ))}
      </div>
    </div>
  )
}

Details.propTypes = {
  data: PropTypes.shape({}).isRequired,
}

Details.displayName = 'Details'

export default Details
